export enum DistanceCalculationType {
		mskSpb = 1, // МСК и СПБ удаленность рассчитывается от МКАД и КАД
		fromPerformerCityBorder = 2, // Удаленность отсчитывается от границ города расположения Исполнителя СЦ
		fromPerformerCityBorderWithBufferZone = 3, // Удаленность отсчитывается от границ города расположения Исполнителя СЦ + буферная зона
		fromPerformerWarehouse = 4, // Удаленность отсчитывается от адреса расположения склада Исполнителя СЦ
}
